import { render, staticRenderFns } from "./ProductManagementISO.vue?vue&type=template&id=08541d26&scoped=true"
import script from "./ProductManagementISO.vue?vue&type=script&lang=js"
export * from "./ProductManagementISO.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementISO.vue?vue&type=style&index=0&id=08541d26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08541d26",
  null
  
)

export default component.exports